module.exports = __webpack_public_path__ + "static/media/refpredictor.77ab43d3.svg";